import { VALIDATION_STATE } from "../hooks/useValidation";
import { BaseValidator } from "./BaseValidator";
import { DateTime } from "luxon";
function stringToDate(date) {
    if (date === undefined) {
        return undefined;
    }
    return DateTime.fromFormat(date, "yyyy-LL-dd").toJSDate();
}
export class MinAgeTinValidator extends BaseValidator {
    constructor(minAge, tinParser, error) {
        super(error);
        this.name = "MinAgeTinValidator";
        this.minAge = minAge;
        this.TinParser = tinParser;
    }
    getId() {
        return this.getBaseId() + this.minAge;
    }
    validate(value) {
        if (value.length === 0) {
            return Promise.resolve({
                status: VALIDATION_STATE.SUCCESS,
                hideError: true,
            });
        }
        return new Promise((resolve) => {
            const TinParser = this.TinParser;
            const tin = new TinParser(value);
            if (!tin.isValid()) {
                return resolve({
                    status: VALIDATION_STATE.SUCCESS,
                    message: this.error,
                    hideError: true,
                });
            }
            const minAgeDate = DateTime.local()
                .minus({ years: this.minAge })
                .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
                .toJSDate();
            const birthDate = stringToDate(tin.getBirthDate());
            if (!birthDate) {
                return resolve({
                    status: VALIDATION_STATE.FAILED,
                    message: this.error,
                    hideError: false,
                });
            }
            if (birthDate <= minAgeDate) {
                return resolve({ status: VALIDATION_STATE.SUCCESS });
            }
            resolve({
                status: VALIDATION_STATE.FAILED,
                message: this.error,
                hideError: false,
            });
        });
    }
}
